function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  rx: 8,
  fill: "#FEEEEA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 42.5C17.675 42.5 16.969 42.2065 16.382 41.6195C15.794 41.0315 15.5 40.325 15.5 39.5V12.5C15.5 11.675 15.794 10.9685 16.382 10.3805C16.969 9.7935 17.675 9.5 18.5 9.5H33.5C34.325 9.5 35.0315 9.7935 35.6195 10.3805C36.2065 10.9685 36.5 11.675 36.5 12.5V39.5C36.5 40.325 36.2065 41.0315 35.6195 41.6195C35.0315 42.2065 34.325 42.5 33.5 42.5H18.5ZM18.5 35V39.5H33.5V35H18.5ZM26 38.75C26.425 38.75 26.7815 38.606 27.0695 38.318C27.3565 38.031 27.5 37.675 27.5 37.25C27.5 36.825 27.3565 36.469 27.0695 36.182C26.7815 35.894 26.425 35.75 26 35.75C25.575 35.75 25.219 35.894 24.932 36.182C24.644 36.469 24.5 36.825 24.5 37.25C24.5 37.675 24.644 38.031 24.932 38.318C25.219 38.606 25.575 38.75 26 38.75ZM18.5 32H33.5V17H18.5V32ZM18.5 14H33.5V12.5H18.5V14Z",
  fill: "#F2512D"
});

function SvgStepInfo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepInfo1);
export default __webpack_public_path__ + "static/media/step_info_1.d495ff43.svg";
export { ForwardRef as ReactComponent };